export const GET_PET_MEDIA_REQUEST = 'GET_PET_MEDIA_REQUEST';
export const GET_PET_MEDIA_SUCCESS = 'GET_PET_MEDIA_SUCCESS';
export const GET_PET_MEDIA_FAILED = 'GET_PET_MEDIA_FAILED';

export const GET_MEDIA_INFO_REQUEST = 'GET_MEDIA_INFO_REQUEST';
export const GET_MEDIA_INFO_SUCCESS = 'GET_MEDIA_INFO_SUCCESS';
export const GET_MEDIA_INFO_FAILED = 'GET_MEDIA_INFO_FAILED';

export const SET_MEDIA_INFO_REQUEST = 'SET_MEDIA_INFO_REQUEST';
export const SET_MEDIA_INFO_SUCCESS = 'SET_MEDIA_INFO_SUCCESS';
export const SET_MEDIA_INFO_FAILED = 'SET_MEDIA_INFO_FAILED';

export const GET_MEDIA_URL_REQUEST = 'GET_MEDIA_URL_REQUEST';
export const GET_MEDIA_URL_SUCCESS = 'GET_MEDIA_URL_SUCCESS';
export const GET_MEDIA_URL_FAILED = 'GET_MEDIA_URL_FAILED';

export const DELETE_PET_MEDIA_REQUEST = 'DELETE_PET_MEDIA_REQUEST';
export const DELETE_PET_MEDIA_SUCCESS = 'DELETE_PET_MEDIA_SUCCESS';
export const DELETE_PET_MEDIA_FAILED = 'DELETE_PET_MEDIA_FAILED';

export const RETRY_MEDIA_PROCESSING_REQUEST = 'RETRY_MEDIA_PROCESSING_REQUEST';
export const RETRY_MEDIA_PROCESSING_SUCCESS = 'RETRY_MEDIA_PROCESSING_SUCCESS';
export const RETRY_MEDIA_PROCESSING_FAILED = 'RETRY_MEDIA_PROCESSING_FAILED';

export const SET_ACTIVE_MEDIA = 'SET_ACTIVE_MEDIA';
